import { QueryClient } from '@tanstack/react-query';

/**
 * Writes use `networkMode: 'always'`: by default the library pauses a mutation while the browser is offline, which
 * would stop it before our own handling runs. Offline writes are caught and queued in the outbox instead (D-088).
 * Reads keep the default and simply wait for the connection.
 */
export function createQueryClient(overrides: { retryQueries?: boolean; staleTime?: number } = {}): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: overrides.staleTime ?? 30_000,
        retry: overrides.retryQueries === false ? false : (count, err) => !(err instanceof Error && err.name === 'ApiError') && count < 2,
        refetchOnWindowFocus: false,
      },
      mutations: { networkMode: 'always' },
    },
  });
}
